import styles from './RouteFallback.module.css'

/**
 * Lightweight CSS spinner used as the Suspense fallback for lazy
 * route chunks. Intentionally avoids antd to keep this off the
 * initial bundle — antd is now only pulled in by the page that
 * actually uses it.
 */
export default function RouteFallback() {
  return (
    <div className={styles.wrap} role="status" aria-label="Loading">
      <div className={styles.spinner} />
    </div>
  )
}
